import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { SECTIONS, reportActions } from '../../../store/reportStore';
import { Translate } from 'react-localize-redux';
import { withLocalize } from "react-localize-redux";
import classnames from 'classnames';
import OldStyleSection from '../../common/oldStyleSection';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import RelationLink from './relationLink';

import GreenSemaphore from '../../../img/icons/GreenSemafor';
import RedSemaphore from '../../../img/icons/RedSemafor';
import YellowSemaphore from '../../../img/icons/YellowSemafor';

class RelationSection extends React.Component {
    render() {
        const { data, pageSize, isLimited } = this.props;
        return (isNullOrUndefined(data) || isNullOrUndefined(data.relations) || data.relations.length === 0) ? null : this.renderContent(data, pageSize, isLimited);
    }

    renderContent = (data, pageSize, isLimited) => {
        const isOwnerRelationId = data.id === "NR03_R" || data.id === "NR03_I";

        const actualRelations = data.relations;
        const historicalRelations = {};

        if (!this.props.isReliability) {
            actualRelations = data.relations.filter(f => f.isActive);
            historicalRelations = data.relations.filter(f => !f.isActive);
        }

        if (data.name === null || data.name === undefined) {
            return this.renderSectionContent(actualRelations, historicalRelations, isOwnerRelationId, pageSize, isLimited, false);
        }

        return (
            <OldStyleSection name={data.name} hasData={actualRelations.length > 0 || historicalRelations.length > 0} isOpen isBold hasSpace>
                {this.renderSectionContent(actualRelations, historicalRelations, isOwnerRelationId, pageSize, isLimited, false)}
            </OldStyleSection>
        )
    }

    renderSectionContent = (actualRelations, historicalRelations, isOwnerRelationId, pageSize, isLimited, hasLeftOffset) => {
        return (
            <OldStyleTableWithHistory offsetLeft={hasLeftOffset} stripped classNames={this.props.isReliability ? 'table-report-section table-stretched' : 'related-addresses'}
                head={() => this.renderHeader(isOwnerRelationId)} tableColumns={this.props.isReliability ? 7 : 8}
                actualData={actualRelations} actualRow={(r) => this.actualRow(r, isOwnerRelationId)}
                historyData={historicalRelations} historyRow={(r) => this.historyRow(r, isOwnerRelationId)}
                isLimited={isLimited} pageSize={pageSize}
                showAllLink={this.props.getUnlimitedSectionLink(this.props.reportType, this.props.id, SECTIONS.relationsData)}
                resolveExpanded={this.props.resolveExpanded}
            />
        );
    }

    renderHeader = (isOwnerRelationId) => {
        return (
            <thead className="relations-header">
                <tr>
                    {!this.props.isReliability && <th className="col-1" />}
                    <th className={classnames({ "col-2": this.props.isReliability })}><Translate id="Report.Relations.EntityName" /></th>
                    <th className="col-3"><Translate id="Report.Relations.EntityIdentification" /></th>
                    <th className="col-4"><Translate id="Report.Relations.Position" /></th>
                    <th className="col-5">{isOwnerRelationId ? <Translate id="Report.Relations.ShareDeposit" /> : null}</th>
                    {this.props.isReliability && <th className="col-6"><Translate id="Report.Relations.WarningInfo" /></th>}
                    <th className="col-7 col-date" style={{ textAlign: 'right' }}><Translate id="Report.Common.ValidFrom" /></th>
                    <th className="col-8 col-date" style={{ textAlign: 'right' }}><Translate id="Report.Common.ValidTo" /></th>
                    {!this.props.isReliability && <th className="col-9"><Translate id="Report.Relations.Country" /></th>}
                </tr>
            </thead>
        );
    }

    actualRow = (r, ownerRelations) => {
        return (
            <tr key={r.id} className='relations-row colorize'>
                {!this.props.isReliability && (this.renderSemaphore(r.semaphoreCode) !== null ? <td className='semaphore-td col-1'>{this.renderSemaphore(r.semaphoreCode)}</td> : <td className="col-1"></td>)}
                <td className="col-2"><RelationLink wrap entityName={r.name} entityId={r.entityId} reports={r.reports} customPrefix={<></>} showOnMobile={true} /></td>
                <td className="col-3">{this.renderEntityIdentification(r)}</td>
                <td className="col-4" colSpan={ownerRelations ? 1 : 2}>{r.position}</td>
                {ownerRelations ? <td className="col-5" style={{ display: "table-cell" }}>{this.renderOwnerShare(r)}</td> : null}
                {this.props.isReliability && <td className="col-6">{this.renderWarnings(r.warnings)}</td>}
                <td className="col-7 col-date" style={{ textAlign: 'right' }}>{r.startDateFormated}</td>
                <td className="col-8 col-date" style={{ textAlign: 'right' }}>{r.endDateFormated}</td>
                {!this.props.isReliability && <td className="col-9" title={r.country}>{r.countryCode}</td>}
            </tr>
        );
    }

    historyRow = (r, ownerRelations) => {
        return (
            <tr key={r.id} className='relations-row colorize old-style-table-report-history-row'>
                {!this.props.isReliability && (this.renderSemaphore(r.semaphoreCode) !== null ? <td className='semaphore-td col-1'>{this.renderSemaphore(r.semaphoreCode)}</td> : <td className="col-1"></td>)}
                <td className="col-2"><RelationLink entityName={r.name} entityId={r.entityId} reports={r.reports} customPrefix={<></>} showOnMobile={true} /></td>
                <td className="col-3">{this.renderEntityIdentification(r)}</td>
                <td className="col-4" colSpan={ownerRelations ? 1 : 2}>{r.position}</td>
                {ownerRelations ? <td className="col-5" style={{ display: "table-cell" }} >{this.renderOwnerShare(r)}</td> : null}
                {this.props.isReliability && <td className="col-6">{this.renderWarnings(r.warnings)}</td>}
                <td className="col-7 col-date" style={{ textAlign: 'right' }}>{r.startDateFormated}</td>
                <td className="col-8 col-date" style={{ textAlign: 'right' }}>{r.endDateFormated}</td>
                {!this.props.isReliability && <td className="col-9" title={r.country}>{r.countryCode}</td>}
            </tr>
        );
    }

    renderSemaphore = (code) => {
        if (code === undefined || code === null)
            return null;

        if (code === 1)
            return <div><GreenSemaphore /></div>
        else if (code === 2)
            return <div><YellowSemaphore /></div>
        else if (code === 3)
            return <div><RedSemaphore /></div>

        return null;
    }

    renderWarnings = (warnings, historical = false) => {
        if (warnings === undefined || warnings === null || warnings.length === 0)
            return null;

        return (
            <React.Fragment>
                <div style={{ display: "flex", whiteSpace: "pre-wrap", flexWrap: 'wrap' }}>
                    {warnings.map((w, i) =>
                        <div key={`${i}_${w.code}`} className={`r-padded rel-warn rel-warn-status-${w.severity}${(historical ? " rel-warn-historical" : "")}`}
                            title={w.description}
                        >{w.code}
                        </div>)}
                </div>
            </React.Fragment>
        );
    }

    renderEntityIdentification = (entity) => {
        if (entity === undefined || entity === null)
            return null;

        if (entity.birthDate !== undefined && entity.birthDate !== null)
            return entity.birthDateFormated;
        else
            return entity.companyId;
    }

    renderOwnerShare = (entity) => {
        if (entity === undefined || entity === null)
            return null;

        if (entity.share === null && entity.depositValue === null)
            return null;

        return (
            <React.Fragment>
                <span style={{ whiteSpace: "nowrap", display: "inline-flex" }}>{entity.shareFormated}<span className="l-padded r-padded">/</span></span>
                <span style={{ whiteSpace: "nowrap", display: "inline-flex" }}>{entity.depositValueFormated}&nbsp;</span>
                <span>
                    {entity.currencyUnit === 1000 && <><Translate id="Report.Common.CurrencyThousands" /><span className="l-padded" /></>}
                    {entity.currency}
                </span>
            </React.Fragment>
        );
    }
}

export default withLocalize(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(RelationSection));